<div class="row" *ngIf="carrier != null && carrier.name != null">
    <div class="wrapper col-sm-12">
        <kendo-expansionpanel [title]="carrier.carrierCode + ' - ' + carrier.name"
                              [subtitle]="carrier.address1 + ',' + searchCityState.cityST + ' ' + searchCityState.zip"
                              [expanded]="true">
            <ng-template kendoExpansionPanelTitleDirective>
                <div class="header-content">
                    <span>
                        {{carrier.carrierCode}} - {{carrier.name}}
                    </span>
                    <rmis-status [rmisStatusColor]="searchCarrier.rmisStatusColor" [rmisStatusTextColor]="searchCarrier.rmisStatusTextColor" [rmisStatusAbbrev]="searchCarrier.rmisStatusAbbrev" [rmisStatusTooltip]="searchCarrier.nonCertifiedReasons"></rmis-status>
                </div>
            </ng-template>
            <kendo-tabstrip (tabSelect)="onTabSelect($event)">
                <kendo-tabstrip-tab title="Profile" [selected]="true">
                    <ng-template kendoTabContent>
                        <div style="padding-right:15px;">
                            <carrier-form [carrierID]="carrier.carrierID" (carrierSaved)="carrierSaved($event)"></carrier-form>
                        </div>
                    </ng-template>
                </kendo-tabstrip-tab>
                <kendo-tabstrip-tab title="Carrier Team">
                    <ng-template kendoTabContent>
                        <div class="content col-sm-6">
                            <carrier-team-assigned [carrierID]="carrier.carrierID"></carrier-team-assigned>
                        </div>
                    </ng-template>
                </kendo-tabstrip-tab>
                <kendo-tabstrip-tab title="Tags">
                    <ng-template kendoTabContent>
                        <div class="content col-sm-6">
                            <tagmap-select [recordID]="carrier.carrierID"
                                           [recordTypeName]="'Carrier'"
                                           (onRefresh)="refreshData('tags')">
                            </tagmap-select>
                        </div>
                    </ng-template>
                </kendo-tabstrip-tab>
            </kendo-tabstrip>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Score Card'"
                              [subtitle]="''"
                              [expanded]="true">
            <div class="content col-sm-12">
                <div class="card-list">
                    <kendo-card width="200">
                        <kendo-card-header class="bg-secondary text-white text-center">
                            <h1 kendoCardTitle>On Time Performance</h1>
                        </kendo-card-header>
                        <kendo-card-body class="text-center" [ngClass]="getScoreCardClass('onTimePercentage')">
                            <h1>{{carrierScoreCard.onTimePercentage}}%</h1>
                        </kendo-card-body>
                    </kendo-card>
                    <kendo-card width="200">
                        <kendo-card-header class="bg-secondary text-white text-center">
                            <h1 kendoCardTitle>Loads On Macropoint</h1>
                        </kendo-card-header>
                        <kendo-card-body class="text-center" [ngClass]="getScoreCardClass('loadsOnMacropointPercentage')">
                            <h1>{{carrierScoreCard.loadsOnMacropointPercentage}}%</h1>
                        </kendo-card-body>
                    </kendo-card>
                    <kendo-card width="200">
                        <kendo-card-header class="bg-secondary text-white text-center">
                            <h1 kendoCardTitle>Order Verification</h1>
                        </kendo-card-header>
                        <kendo-card-body class="text-center" [ngClass]="getScoreCardClass('verifiedOnTime')">
                            <h1>{{carrierScoreCard.verifiedOnTime}}%</h1>
                        </kendo-card-body>
                    </kendo-card>
                    <kendo-card width="200">
                        <kendo-card-header class="bg-secondary text-white text-center">
                            <h1 kendoCardTitle># Incident Reports Logged</h1>
                        </kendo-card-header>
                        <kendo-card-body class="text-center" [ngClass]="getScoreCardClass('incidentReports')">
                            <h1>{{carrierScoreCard.incidentReports}}</h1>
                        </kendo-card-body>
                    </kendo-card>
                    <kendo-card width="200">
                        <kendo-card-header class="bg-secondary text-white text-center">
                            <h1 kendoCardTitle>Loads Ran Last 30 Days</h1>
                        </kendo-card-header>
                        <kendo-card-body class="text-center" [ngClass]="getScoreCardClass('loadsRanLast30Days')">
                            <h1>{{carrierScoreCard.loadsRanLast30Days}}</h1>
                        </kendo-card-body>
                    </kendo-card>
                    <kendo-card width="200">
                        <kendo-card-header class="bg-secondary text-white text-center">
                            <h1 kendoCardTitle>Last 30 Days Net Revenue</h1>
                        </kendo-card-header>
                        <kendo-card-body class="text-center" [ngClass]="getScoreCardClass('last30DaysNetRevenue')">
                            <h1>${{carrierScoreCard.last30DaysNetRevenue}}</h1>
                        </kendo-card-body>
                    </kendo-card>
                </div>
            </div>
            <!--<customer-opportunity-grid [customerID]="customer.customerId" (opportunitySaved)="opportunitySaved($event)"></customer-opportunity-grid>-->
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Contacts'"
                              [subtitle]="'Total: ' + contacts.length"
                              [expanded]="false">
            <contact-grid [contactType]="'Carrier'" [tableID]="carrier.carrierID" [countryCode]="searchCityState.countryAbbr"></contact-grid>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Equipment & Services'"
                              [subtitle]="''"
                              [expanded]="false"
                              (expandedChange)="panelExpandedChange('EquipmentServices', $event)">
            <div class="row">
                <div class="col-sm-4">
                    <kendo-expansionpanel [title]="'Services'"
                                          [subtitle]="''"
                                          [expanded]="true">
                        <div style="height:300px;overflow:scroll;">
                            <table>
                                <tr *ngFor="let item of carrierServiceList">
                                    <td><input type="checkbox" [(ngModel)]="item.isChecked" [checked]="item.isChecked" (change)="saveCarrierServiceMaps(item)" style="margin:5px;transform: scale(1.5);" /></td>
                                    <td (click)="setCarrierServiceMap(item)">{{item.abbreviation}}</td>
                                    <td (click)="setCarrierServiceMap(item)">{{item.description}}</td>
                                </tr>
                            </table>
                        </div>
                    </kendo-expansionpanel>
                </div>
                <!--<div class="col-sm-1">
                <label style="margin-top: 5px;">Services</label>
            </div>
            <div class="col-sm-6">
                <kendo-multiselect [data]="carrierServiceList"
                                   [valuePrimitive]="true"
                                   [textField]="'description'"
                                   [valueField]="'carrierServiceID'"
                                   [popupSettings]="{ appendTo: 'component' }"
                                   [(ngModel)]="carrierServiceIDList">
                </kendo-multiselect>
            </div>
            <div class="col-sm-3">
                <button style="margin-top: 3px;" class="epi-button" (click)="saveCarrierServiceMaps()">Save</button>
            </div>-->
                <div class="col">
                    <kendo-expansionpanel [title]="'Equipment'"
                                          [subtitle]="''"
                                          [expanded]="true"
                                          *ngIf="showEquipment">
                        <carrier-equipment-grid [carrierID]="carrier.carrierID"></carrier-equipment-grid>
                    </kendo-expansionpanel>
                </div>
            </div>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Customer Exclusion & Incidents'"
                              [subtitle]="''"
                              [expanded]="false"
                              (expandedChange)="panelExpandedChange('CustomerExclusionIncidents', $event)">
            <div class="row">
                <div class="col-sm-6">
                    <kendo-expansionpanel [title]="'Customer Exclusion'"
                                          [subtitle]="''"
                                          [expanded]="true"
                                          *ngIf="showCustomerExclusion">
                        <carrier-customer-exclusion-grid [carrierID]="carrier.carrierID"></carrier-customer-exclusion-grid>
                    </kendo-expansionpanel>
                </div>
                <div class="col">
                    <kendo-expansionpanel [title]="'Incidents'"
                                          [subtitle]="''"
                                          [expanded]="true"
                                          *ngIf="showIncidents">
                        <carrier-incident-grid [carrierID]="carrier.carrierID"></carrier-incident-grid>
                    </kendo-expansionpanel>
                </div>
            </div>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Lanes'"
                              [subtitle]="''"
                              [expanded]="false"
                              (expandedChange)="panelExpandedChange('Lanes', $event)">
            <div class="row" *ngIf="showLanes">
                <div class="col">
                    <carrier-lane-grid [carrierID]="carrier.carrierID" [isAddLanes]="true"></carrier-lane-grid>
                </div>
            </div>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'RFQ & Analysis'"
                              [subtitle]="''"
                              [expanded]="false"
                              (expandedChange)="panelExpandedChange('RFQAnalysis', $event)">
            <div class="row">
                <div class="col-sm-6">
                    <kendo-expansionpanel [title]="'RFQ'"
                                          [subtitle]="''"
                                          [expanded]="true"
                                          *ngIf="showRFQ">
                        <!--<carrier-customer-exclusion-grid [carrierID]="carrier.carrierID"></carrier-customer-exclusion-grid>-->
                        <carrier-rfq-grid [opportunityID]="opportunityID">
                        </carrier-rfq-grid>
                    </kendo-expansionpanel>
                </div>
                <div class="col-sm-6">
                    <kendo-expansionpanel [title]="'Analysis'"
                                          [subtitle]="''"
                                          [expanded]="true"
                                          *ngIf="showAnalysis">
                        <carrier-analysis-grid [carrierID]="carrier.carrierID"></carrier-analysis-grid>
                    </kendo-expansionpanel>
                </div>
            </div>
        </kendo-expansionpanel>
    </div>
</div>
